import { TasksModule } from './tasks/tasks.module';
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// Partials
import { PartialsModule } from '../partials/partials.module';
// Pages
import { CoreModule } from '../../core/core.module';
import { MailModule } from './apps/mail/mail.module';
import { FileReturnModule } from './fileReturn/fileReturn.module';
import { BugsModule } from './bugs/bugs.module';
import { CashierModule } from './cashier/cashier.module';
import { BilletModule } from './billet/billet.module';
import { ManagerModule } from './manager/manager.module';
import { AccountingModule } from './accounting/accounting.module';
import { NlogComponent } from './nlog/nlog.component';
import { AgreementExternalCollectorModule } from './agreement-external-collector/agreement-external-collector.module';

/***angular material */
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { PixResultsComponent } from './pix-results/pix-results.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DialogInputComponent } from './pix-results/dialog/dialog-input/dialog-input.component';
import { DialogSelectBilletComponent } from './pix-results/dialog/select-billet/select-billet.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AutomaticDebitModule } from './automatic-debit/automatic-debit.module';
import { CollectorFileModule } from './collector-file/collector-file.module';
import { UpdatePixStatusComponent } from './pix-results/dialog/update-pix-status/update-pix-status.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

var angularMaterial = [
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatTableModule,
    MatTabsModule,
    MatMenuModule,
    MatCardModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatSelectModule,
    FormsModule,
    MatDatepickerModule,
    MatCheckboxModule,
];

@NgModule({
    declarations: [
        NlogComponent,
        PixResultsComponent,
        DialogInputComponent,
        DialogSelectBilletComponent,
        UpdatePixStatusComponent,
    ],
    exports: [],
    imports: [
        CommonModule,
        HttpClientModule,
        FileReturnModule,
        AgreementExternalCollectorModule,
        CoreModule,
        PartialsModule,
        MailModule,
        TasksModule,
        BugsModule,
        CashierModule,
        BilletModule,
        ManagerModule,
        AccountingModule,
        angularMaterial,
        BrowserModule,
        NgbModule,
        AutomaticDebitModule,
        CollectorFileModule,
    ],
    providers: [],
})
export class PagesModule {}
